import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';

//Servicios
import { DefaultService } from '../../services/default.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [
    DefaultService
  ]
})
export class HomeComponent implements OnInit {
  public user:any = {};
  public login:boolean = false;

  public home1:string = "";
  public home2:string = "";
  public home3:string = "";
  public home4:string = "";
  public home9:string = "";

  constructor(
    private http: HttpClient,
    public _defaultService: DefaultService,
    public translate: TranslateService,
  ){ 
    this.translate.get('TEXTOS.home1').subscribe(res => {this.home1 = this.traducciones(res); });
    this.translate.get('TEXTOS.home2').subscribe(res => {this.home2 = this.traducciones(res);});
    this.translate.get('TEXTOS.home3').subscribe(res => {this.home3 = this.traducciones(res);});
    this.translate.get('TEXTOS.home4').subscribe(res => {this.home4 = this.traducciones(res);});
    this.translate.get('TEXTOS.home9').subscribe(res => {this.home9 = this.traducciones(res);});
  }

  ngOnInit() {
    this.logeado();
    this.prueeeebas();
  }

  traducciones(res){
     var texto:string = "";
     for(let x=0; x < res.length; x++){
       var text = res[x];
       text = text.toString().replace("xx", "");
       text = text.toString().replace("xx,", "");
        texto += text;
     }

     return texto;
  }

  prueeeebas(){
    this._defaultService.pruebas().subscribe((data) => {
      console.log("Hello!")
    }, err => {
      console.log(err)
    }); 
  }

  logeado(){
    this._defaultService.isLogged().subscribe(result => {
      if(result != null && result.emailVerified == true){
        this._defaultService.Data("users", result.uid).subscribe(user => {
          this.user = user;
          this.http.get<{ip:string}>('https://jsonip.com').subscribe( data => {
              if(this.user.ip != data.ip || this.user.ip == undefined){
                this._defaultService.signOut();
                alert("Hay otro inicio de sesión desde otro dispositivo. Vuelve a iniciar sesión o cambie la contraseña")
              }else{
                this.login = true;
              }
          });
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts